import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import PolicyEndorsementRepository from '../../domains/informacionDevolucion/repositories/policy-endorsement-repository';
import RegisterEndorsementProvider from '../../domains/informacionDevolucion/repositories/register-endorsement-repository';

const initialState = {
    datosPoliza : null,
    solicitudEndoso : null,
    status: "idle",
    error: "",
    statusRegistrar: "idle",
    errorRegistrar:"",
    numeroSolicitudEndoso : 0,
    numeroSolicitudServicio : ''
};

export const getValidarEndosoPoliza = createAsyncThunk("endosoPoliza/getValidarEndosoPoliza", async (datosConsultaPoliza) => {
    return await new PolicyEndorsementRepository().getValidarEndosoPoliza(datosConsultaPoliza).then((resp) => { return resp.data; });
})

export const postRegistrarEndosoPoliza = createAsyncThunk("endosoPoliza/postRegistrarEndosoPoliza", async (datosPoliza) => {
    return await new RegisterEndorsementProvider().postValidarEndosoPoliza(datosPoliza).then((resp) => { return resp.data; });
})

export const endosoPolizaSlice = createSlice({
    name : "endosoPoliza",
    initialState,
    reducers:{
       
    },
    extraReducers: (builder) => {
        builder
            .addCase( getValidarEndosoPoliza.pending, (state) => {
                state.status = "loading";
            })
            .addCase( getValidarEndosoPoliza.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.datosPoliza = action.payload.datos.datosPoliza;
                state.solicitudEndoso = action.payload.datos.solicitudEndoso;
            })
            .addCase( getValidarEndosoPoliza.rejected, (state, action) => {
                state.status = "failed";
                state.error = "Ocurrio un error al procesar su solicitud.";
            })
            .addCase( postRegistrarEndosoPoliza.pending, (state) => {
                state.statusRegistrar = "loading";
            })
            .addCase( postRegistrarEndosoPoliza.fulfilled, (state, action) => {
                state.statusRegistrar = "succeeded";
                state.numeroSolicitudEndoso = action.payload.datos.numeroSolicitudEndoso;
                state.numeroSolicitudServicio = action.payload.datos.numeroSolicitudServicio;
            })
            .addCase( postRegistrarEndosoPoliza.rejected, (state, action) => {
                state.statusRegistrar = "failed";
                state.errorRegistrar = "Ocurrio un error al procesar su solicitud.";
            });
    }
});

export default endosoPolizaSlice.reducer;